module.exports = __webpack_public_path__ + "img/heroFormInflate1.5c7b10d8.svg";